<template>
	<div class="page bg-fff pb-fixed-btn">
		<backTitleBar></backTitleBar>

		<div class="pd-030" style="margin-top: 2rem;" >
			<van-button type="primary" block style="margin-top: .3rem;" @click="changeRole(item.roleName)" v-for="item in roleList" :key="item.roleId">{{item.roleName}}</van-button>
		</div>
	</div>

</template>
<script>
    import backTitleBar from "@/components/titleBar/backTitleBar"
    import {mapActions} from 'vuex'
	export default{
		name:'index',
        components:{backTitleBar},
		data(){
			return {
				roleList: this.$store.state.user && this.$store.state.user.userRoleList ? this.$store.state.user.userRoleList : []
			}
		},
		created(){
			this.$store.state.showFooter = false;

		},
		mounted(){
		},
		methods:{
			...mapActions([
				'setQuarterManageRole',
				'setSupplierRole'
			]),
			changeRole(roleName){
				let quarterManageRole = false,supplierRole = false;
				if(roleName == '小区管理员'){
					quarterManageRole = true;
				}else if(roleName == '补货人员' || roleName == '补货员'){
					supplierRole = true;
				}
				this.setQuarterManageRole(quarterManageRole)
				this.setSupplierRole(supplierRole)
				this.$router.push('/home');
			}
		}
	}
</script>
<style lang="scss" scoped>
	.head-img{
		width: 1.44rem;
		height: 1.44rem;
		display: block;
		margin: 1rem auto 0;
	}
	.my-name{
		text-align: center;
		margin-top: .3rem;
		color: #333;
		font-size: .34rem;
		line-height: .48rem;
		font-weight: 600;
	}
	.role-name{
		margin-top: .1rem;
		text-align: center;
		line-height: .4rem;
		font-size: .26rem;
		color: #999;
	}
	.card {
		margin: 0 .25rem;
		background: #fff;
		border-radius: .24rem;
	}
	.setting-item {
		display: flex;
		padding: .28rem .32rem;
		align-items: center;
		.item-name {
			width: 1.8rem;
			font-size: .34rem;
			line-height: .48rem;
			color: #252D46;
		}
		.item-range {
			width: 3.3rem;
		}
		.item-rang-num {
			flex: 1;
			text-align: right;
			font-size: .32rem;
			line-height: .45rem;
			color: #919BA6;
		}
		.item-right {
			flex: 1;
			text-align: right;
			font-size: .32rem;
			line-height: .45rem;
			color: #919BA6;
		}
		.item-value {
			font-size: .32rem;
			line-height: .45rem;
			color: #919BA6;
			text-align: right;
			flex: 1;
		}
		.item-right-icon {
			font-size: .26rem;
			color: #919BA6;
			margin-left: .2rem;
		}
	}
</style>



// WEBPACK FOOTER //
// roleList.vue?036961ca